import React from 'react';

import { PrimaryButton, SecondaryButton } from '@components/Button/variants';

interface StepUpdateProps {
  nextStep: () => void;
  handleClose: (event: React.MouseEvent<HTMLButtonElement>) => void;
}

const StepUpdate = ({ nextStep, handleClose }: StepUpdateProps) => (
  <div className="onboarding-content center">
    <div>
      <h2 className="onboarding-heading large">Update Your Profile and Preferences</h2>
      <p className="mt2 mb3">
        We have added a lot of powerful tools to The Information. Updating your interests and
        profile information will help us deliver the best experience for you.
      </p>
      <button onClick={nextStep} className="button button-red button-stretch button-small">
        Get started
      </button>
      <button onClick={handleClose} className="onboarding-not-now-button">
        Not now
      </button>
      <PrimaryButton as="button" onClick={nextStep} size="small" fullWidth>
        Get started
      </PrimaryButton>
      <SecondaryButton as="button" onClick={handleClose} size="small" fullWidth>
        Not now
      </SecondaryButton>
    </div>
  </div>
);

export default StepUpdate;
